import  HeroSection from './HeroSection'
import  SecondSection from './SecondSection'
import  GallaryImages from './GallaryImages'
import  FourthSection from './FourthSection'
import  GalleryVideos from './GalleryVideos'


export {  HeroSection, SecondSection, GallaryImages,FourthSection, GalleryVideos}
